import {
  ApplicationAccessControlRatePlanFormDto,
  type ApplicationAccessControlRatePlanFormInterface,
} from '@zaoblako/shared/modules/security/dtos/application/access-control/application-access-control-rate-plan-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';

import * as yup from 'yup';

/** Rate plan create/update form API request body */
export interface RatePlanFormInterface {
  /** Display name */
  name: string;
  /** Additional description (with HTML support) */
  description?: string;
  /** Modules access control settings */
  modulesAccessControl: ApplicationAccessControlRatePlanFormInterface;
  /** Default rate plan flag */
  isDefault?: boolean;
  /** "FRM_AI" module default rate plan flag */
  isManualDefault?: boolean;
  /** Price in Russian Rubles */
  price: number;
}

/** Rate plan create/update form API request body - DTO schema */
export const RatePlanFormDto = SerdeDtoClass.create<RatePlanFormInterface>(SaasDtoKeysEnum.RATE_PLAN_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  description: {
    optional: true,
    label: 'Описание',
    hint: 'Поддерживается HTML-разметка',
    serializer: yup.string(),
  },
  modulesAccessControl: {
    label: 'Настройки доступа к модулям',
    nested: <any>ApplicationAccessControlRatePlanFormDto,
    serializer: (_, nested) => <any>nested,
  },
  isDefault: {
    optional: true,
    label: 'Тариф по-умолчанию',
    serializer: booleanSchema,
  },
  isManualDefault: {
    optional: true,
    label: 'Тариф по-умолчанию для модуля "ФРМ AI"',
    serializer: booleanSchema,
  },
  price: {
    label: 'Цена за пользователя',
    serializer: yup
      .number()
      .min(0, DtoMessageEnum.NOT_POSITIVE),
  },
});
